module.exports = {
    RECEIVE_ALL_SUPPORTS: 'RECEIVE_ALL_SUPPORTS',
    RECEIVE_ALL_SUPPORT_THEMES: 'RECEIVE_ALL_SUPPORT_THEMES',
    RECEIVE_SUPPORT: 'RECEIVE_SUPPORT',
    RECEIVE_SUPPORT_NAMES: 'RECEIVE_SUPPORT_NAMES',
    RESET_SUPPORT: 'RESET_SUPPORT',
}